'use client';
import React from 'react';

export interface StageOption {
  name: string;
  icon: string;
}

interface StageFilterProps {
  stages: StageOption[] | string[];
  activeStage: string;
  onSelectStage: (stage: string) => void;
}

function getStageName(stage: StageOption | string): string {
  return typeof stage === 'string' ? stage : stage.name;
}

function getStageIcon(stage: StageOption | string): string {
  if (typeof stage === 'string') return '🎭';
  return stage.icon || '🎭';
}

export default function StageFilter({ stages, activeStage, onSelectStage }: StageFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => onSelectStage('all')}
        className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all duration-150 ${
          activeStage === 'all' ? 'bg-foreground text-background border-foreground' : 'bg-card text-muted-foreground border-border hover:border-foreground/30 hover:text-foreground'
        }`}
      >
        Alle Bühnen
      </button>
      {stages.map((stage) => {
        const name = getStageName(stage);
        const icon = getStageIcon(stage);
        return (
          <button
            key={`stage-filter-${name}`}
            onClick={() => onSelectStage(name)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all duration-150 ${
              activeStage === name
                ? 'bg-foreground text-background border-foreground'
                : 'bg-card text-muted-foreground border-border hover:border-foreground/30 hover:text-foreground'
            }`}
          >
            {icon} {name}
          </button>
        );
      })}
    </div>
  );
}